<template>
    <div class="d-flex flex-column fill-height" id="campaigns_list">
        <v-overlay :value="isPageLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-row ref="headerFilters" class="flex-grow-0">
            <data-table-filters  v-if="!isMobile"
                name="Campanhas"
                :has-active-filters="hasActiveFilters"
                :has-expanded-active-filters="hasExpandedActiveFilters"
                :filters="filters"
                :schema="schema"
                @expand-active-filters="hasExpandedActiveFilters = $event"
                @remove-filter="removeFilter"
                @refresh="refresh()"
                @clear-filters="onClearFilters()"
            >
            </data-table-filters>
            <div class="col wrap-title-filters" v-else >
                <filters-dialog
                        name="Campanhas"
                        :has-active-filters="hasActiveFilters"
                        :has-expanded-active-filters="hasExpandedActiveFilters"
                        :filters="filters"
                        :schema="schema"
                        @expand-active-filters="hasExpandedActiveFilters = $event"
                        @remove-filter="removeFilter"
                        @refresh="refresh()"
                        @clear-filters="onClearFilters()"
                    >
                </filters-dialog>
            </div>
        </v-row>

        <v-row>
            <v-col cols="12">
                <pure-datatable endpoint="/api/campaigns/simple" @data-changed="onDataChanges" :queryParams="queryParams" :ready="ready" :customSearch="customSearch" ref="datatable" v-slot:default="{ vOn, vBind, updateOptions, isLoading }">
                    <div>
                        <portal to="v-form-base">
                            <v-form-base :model="filters" :schema="schema" @input="onFiltersChanged"> </v-form-base>
                        </portal>

                        <v-data-table id="campaigns"
                            class="elevation-1 d-flex flex-column justify-space-between nowrap-headers"
                            :style="`border-radius: 16px; height: ${datatableSize}px;`"
                            fixed-header
                            multi-sort
                            :headers="headers"
                            :hide-default-headers="isMobile"
                            :class="{mobile: isMobile}"
                            @update:options="refresh"
                            v-on="vOn"
                            v-bind="vBind"
                            hide-default-footer
                            no-data-text="Sem dados disponíveis."
                            no-results-text="Não foram encontrados resultados."
                            :loading="isMobile?isLoading:false"
                            loading-text="A carregar dados..."
                            :header-props="headerProps"
                            :footer-props="{
                                showFirstLastPage: false,
                                itemsPerPageOptions:  itemsPerPageOptions,
                                itemsPerPageText: 'Registos por página',
                            }"
                        >
                            <!--onOpenDetailedCampaignDialog<template v-if="!isMobile" #[`header.has_campaign`]="scope">
                                <v-icon style="left: 10%">mdi-star-outline</v-icon>
                            </template>-->

                            <template v-if="!isMobile" #[`item.name`]="scope">
                                <div class="d-flex justify-start align-center" data-cy="designations">

                                    <!--<div class="datatable-image">
                                        <div class="image-product-list" :style="'background-image: url('+scope.item.thumbnail+');'"
                                        @click="openProductDetails(scope.item)">
                                        </div>
                                    </div>-->
                                    <div style="margin-left: 10px;">
                                        <campaign-tooltip v-if="hasActiveCampaign(scope.item)" isOutlined text="Campanha Aplicada" @click="onOpenDetailedCampaignDialog(scope.item)"></campaign-tooltip>
                                        <campaign-tooltip v-else text="Campanha Não Aplicada" @click="onOpenDetailedCampaignDialog(scope.item)"></campaign-tooltip>
                                    </div>
                                    <div class="pl-2 datatable-designation-text" style="cursor: pointer" @click="onOpenDetailedCampaignDialog(scope.item)">
                                        {{ scope.item.name }}
                                    </div>
                                </div>
                            </template>
                            <template v-if="!isMobile" #[`item.description`]="scope">
                                    <div class="pl-2 datatable-designation-text" style="cursor: pointer" @click="onOpenDetailedCampaignDialog(scope.item)">
                                        {{ scope.item.description }}
                                    </div>
                            </template>

                            <!--<template v-if="!isMobile" #[`item.extraIcons`]="scope">
                                <product-additional-info :product="scope.item"> </product-additional-info>
                            </template>

                            <template v-if="!isMobile" #[`item.active_substances__description`]="scope">
                                <div class="datatable-multi-line-text">
                                    <span v-for="(item, index) in scope.item.active_substances" :key="index">
                                        {{ item.description }}<template v-if="index !== scope.item.active_substances.length - 1"><br /></template>
                                    </span>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.laboratory__name`]="scope">
                                {{ scope.item.laboratory.name }}
                            </template>

                            <template v-if="!isMobile" #[`item.species__description`]="scope">
                                <div class="datatable-multi-line-text">
                                    <span v-for="(item, index) in scope.item.species" :key="index"> {{ item.description }}<template v-if="index !== scope.item.species.length - 1">, </template> </span>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.administration_route__description`]="scope">
                                <span v-if="scope.item.administration_route">
                                    {{ scope.item.administration_route.description }}
                                </span>
                            </template>

                            <template v-if="!isMobile" #[`item.pharma_composition__description`]="scope">
                                <div v-if="scope.item.pharma_composition" class="datatable-multi-line-text">
                                    {{ scope.item.pharma_composition.description }}
                                </div>
                            </template>-->

                            <!--<template v-if="!isMobile" #[`item.has_campaign`]="scope">
                                <template v-if="userStore.hasPermissionTo('View campaigns') && !branchNoCampaigns">
                                    <campaign-tooltip v-if="productHasActiveCampaign(scope.item.id)" isOutlined text="Campanha Aplicada" @click="onClickProductCampaign(scope.item)"></campaign-tooltip>
                                    <campaign-tooltip v-else-if="!productHasActiveCampaign(scope.item.id) && scope.item.has_campaign" text="Com Campanha" @click="onClickProductCampaign(scope.item)"></campaign-tooltip>
                                </template>
                            </template>-->

                            <template v-if="!isMobile" #[`item.actions`]="scope">
                                <div class="d-flex justify-end d-flex align-center">
                                    <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" style="cursor: pointer" @click="onOpenDetailedCampaignDialog(scope.item)"> mdi-dots-horizontal-circle-outline </v-icon>
                                </div>
                            </template>
                            <template v-if="isMobile" v-slot:item="{ item, index }">
                            <tr>
                                <v-card
                                    elevation="2"
                                    >
                                    <v-row>
                                        <v-col class="d-flex flex-column col pt-0 pb-0">
                                            <v-row class="d-flex align-start pt-0 pb-0">
                                                <v-col class="col col-4 px-0 pt-0 pb-0 wrap-l">
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" style="min-height: 31px;"></v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" :style="setHeightByStringSize(item.name)>0?'min-height: '+setHeightByStringSize(item.name)+'px;':''">NOME</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" :style="setHeightByStringSize(item.description)>10?'min-height: '+setHeightByStringSize(item.description)+'px;':''" v-if="item.description!=null">DESCRIÇÃO</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" style="min-height: 31px;">LABORATÓRIO</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" style="min-height: 31px;">ESPÉCIES</v-col>
                                                </v-col>
                                                <v-col class="col col-8  pt-0 pb-0 wrap-r">
                                                    <v-col class="col col-12 px-0 pt-0 pb-0">
                                                        <v-col class="d-flex px-0 mx-0 pt-0 pb-0 flex-column" style="min-height: 31px;">
                                                            <v-col class="d-flex align-start px-0 pt-0 pb-0">
                                                                <v-col class="col col-10 px-0 pt-0 pb-0 field-r ">

                                                                        <campaign-tooltip v-if="hasActiveCampaign(item)" isOutlined text="Campanha Aplicada" @click="onOpenDetailedCampaignDialog(item)"></campaign-tooltip>
                                                                        <campaign-tooltip v-else text="Campanha Não Aplicada" @click="onOpenDetailedCampaignDialog(scope.item)"></campaign-tooltip>
                                                                </v-col>
                                                                <v-col class="col col-2 px-0 pt-0 pb-0">
                                                                        <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" style="cursor: pointer" @click="onOpenDetailedCampaignDialog(item)"> mdi-dots-horizontal-circle-outline </v-icon>
                                                                </v-col>
                                                        </v-col>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" :style="setHeightByStringSize(item.name)>0?'min-height: '+setHeightByStringSize(item.name)+'px;':''">
                                                        <div class="datatable-designation-text" style="cursor: pointer" @click="onOpenDetailedCampaignDialog(item)">
                                                            {{ item.name }}
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" :style="setHeightByStringSize(item.description)>0?'min-height: '+setHeightByStringSize(item.description)+'px;':''" v-if="item.description!=null">
                                                        <div class="datatable-designation-text" style="cursor: pointer" @click="onOpenDetailedCampaignDialog(item)">
                                                            {{ item.description }}
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" style="min-height: 31px;">
                                                        <div class="datatable-designation-text" style="cursor: pointer" @click="onOpenDetailedCampaignDialog(item)">
                                                            {{ item.laboratory }}
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" style="min-height: 31px;">
                                                        <div class="datatable-designation-text" style="cursor: pointer" @click="onOpenDetailedCampaignDialog(item)">
                                                            <span v-for="(item3, index3) in item.species" :key="index3"> {{ item3 }}<span v-if="index3 !== item.species.length - 1">, </span> </span>
                                                        </div>
                                                    </v-col>
                                                    </v-col>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </tr>

                        </template>

                            <template v-slot:footer="scope">
                                <div>
                                    <div class="datatable-footer-border"></div>

                                    <data-table-footer :scope="scope" @updateOptions="updateOptions" :isLoading="isLoading" :showExport="false" :showOrderButton="false" style="height: fit-content"> </data-table-footer>
                                </div>
                            </template>
                        </v-data-table>
                    </div>
                </pure-datatable>
            </v-col>
        </v-row>
      <!--- <v-row>
            <v-col>
                <portal to="v-form-base">
                    <v-form-base :model="filters" :schema="schema" @input="onFiltersChanged"></v-form-base>
                </portal>

                <app-card class="d-flex flex-column align-stretch fill-height py-4 px-4">
                    <template v-slot:image>
                        <div class="d-flex justify-center">
                            <v-tabs show-arrows centered id="myprovet-tabs" v-model="selectedTab.index" next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left" height="35px" style="border-radius: 8px; padding-left: 11px">
                                <v-tabs-slider color="#154579"></v-tabs-slider>

                                <v-tab class="myprovet-tab-item" v-for="item in tabItems" :key="item.tab">
                                    {{ item.tab }}
                                </v-tab>
                            </v-tabs>
                        </div>

                        <loading-indicator v-if="isLoading" :loading="isLoading"> </loading-indicator>

                        <template v-else-if="campaigns.items.length > 0">
                            <div class="d-flex fill-height justify-space-between">
                                <div class="d-flex align-center">
                                    <v-btn :disabled="campaigns.currentPage === 1" icon elevation="1" class="mr-3 appbar-icon-button btn-bg-color-blue dark-blue-color" @click="changeCampaignPage(-1)">
                                        <v-icon>mdi-arrow-left</v-icon>
                                    </v-btn>
                                </div>

                                <div class="d-flex align-center" style="width: 100%">
                                    <v-container fluid>
                                        <v-row dense>
                                            <v-col v-for="campaign in campaigns.items" :key="campaign.id" cols="3">
                                                <v-card>
                                                    <v-img :src="campaign.src" class="white--text align-end" gradient="to bottom, rgba(21,69,121,.8), rgba(21,69,121,.5)" height="200px">
                                                        <v-card-title v-text="campaign.name" class="font-size-lg"></v-card-title>
                                                        <v-card-subtitle v-text="campaign.description" class="font-size-sm"></v-card-subtitle>
                                                    </v-img>

                                                    <v-card-actions>
                                                        <v-row dense>
                                                            <v-col cols="12">
                                                                <div class="d-flex justify-center">
                                                                    <v-btn text class="myprovet-btn-ok" @click="onOpenDetailedCampaignDialog(campaign)" v-html="isMobile?'Ver':'Ver Campanha'"> </v-btn>
                                                                </div>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </div>

                                <div class="d-flex align-center">
                                    <v-btn :disabled="!hasMoreCampaignPages" icon elevation="1" class="ml-3 appbar-icon-button btn-bg-color-blue dark-blue-color" @click="changeCampaignPage(1)">
                                        <v-icon>mdi-arrow-right</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </template>

                        <template v-else>
                            <div class="d-flex fill-height justify-center">
                                <div class="d-flex align-center">Sem campanhas disponíveis</div>
                            </div>
                        </template>
                    </template>
                </app-card>
            </v-col>
        </v-row>-->

        <product-campaign-form
            v-if="isDetailedCampaignDialogOpen"
            :isOpen="isDetailedCampaignDialogOpen"
            :product="product"
            :campaigns="manipulatedProductCampaigns"
            :account-blocked-message="accountBlockedMessage"
            @input="onCloseDetailedCampaignDialog()"
            @check-applied-campaigns="checkAppliedCampaigns()"
            @create-new-original-campaign="createNewOriginalCampaign($event)"
            @show-campaigns="onClickProductCampaign"
        ></product-campaign-form>

        <app-dialog v-if="isProductDetailsDialogOpen" :value="isProductDetailsDialogOpen" @input="isProductDetailsDialogOpen = $event" title="Ficha do Produto" width="55vw" :isProductDetails="true" :isResponsive="true" :showActions="false">
            <template v-slot:content>
                <product-details :product="selectedProduct" :key="selectedProduct.id" @change-product="selectedProduct = $event" @show-campaigns="onClickProductCampaign"></product-details>
            </template>
        </app-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';
import { buildQueryObjectFromModel } from '@arentia/atools/QueryBuilder';
import PureDatatable from '@arentia/atools/PureDatatable';
import MainLayout from './../../Layouts/MainLayout';
import VFormBase from 'vuetify-form-base';
import ResizeObserver from 'resize-observer-polyfill';

export default {
    layout: MainLayout,

    components: {
        VFormBase,
        PureDatatable
    },

    props: {
        model: [Object, Array],
        schema: [Object, Array],
        headers: [Object, Array],
        product: Object,
        accountBlockedMessage: String,
    },

    data: () => ({
        filters: {},
        queryParams: {},
        ready: false,
        hasExpandedActiveFilters: false,
        datatableSize: 200,
        resizeObserver: null,

        isPageLoading: false,
        isLoading: true,

        selectedTab: {
            id: 0,
            index: -1,
            name: '',
        },
        tabItems: [],

        campaigns: {
            currentPage: 1,
            lastPage: 1,
            items: [],
        },

        originatingProductId: 999999,
        manipulatedProductCampaigns: [],
        productCampaigns: [],
        originalProductCampaigns: [],

        selectedProduct: {},
        selectedCampaign: {},

        isDetailedCampaignDialogOpen: false,
        isProductDetailsDialogOpen: false,
        itemsPerPageOptions:window.innerWidth>=768&&window.innerWidth<=1366?[25,50,80]:[15,20,50],
        customSearch: {
            name: `{
                "type": "query-builder-group",
                "query": {
                    "logicalOperator": "any",
                    "children": [
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "name",
                                "operator": "keywords",
                                "operand": "name",
                                "value": "__name__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "description",
                                "operator": "contains",
                                "operand": "description",
                                "value": "__name__"
                            }
                        }
                    ]
                }
            }`,
        },
    }),

    watch: {
        'branchStore.branch': {
            handler: function (branch) {
                if (!branch) return;

                // Return to Dashboard page if branch's no_campaigns property is true.
                //if (branch && branch.no_campaigns) this.$inertia.visit('/dashboard');
                this.queryParams.branch_id = branch.id;
                this.ready=true
                this.refresh();
            },
            immediate: true,
        },

        /*'selectedTab.index': {
            handler: function (index) {
                if (this.tabItems.length > 0) {
                    this.$set(this.filters, 'requirements__product__laboratory__name', this.tabItems[index]?.tab);
                    this.campaigns.currentPage = 1; // Reset the current page
                    this.onFiltersChanged();
                }
            },
            immediate: true,
        },

        tabItems: {
            handler: function (items) {
                if (items.length > 0) {
                    if (this.selectedTab.index === -1) this.$set(this.selectedTab, 'index', 0);
                    this.$set(this.selectedTab, 'id', items[this.selectedTab.index]?.id);
                    this.$set(this.selectedTab, 'name', items[this.selectedTab.index]?.tab);
                } else {
                    this.setDefaultSelectedTab();
                }
            },
            immediate: true,
        },*/
    },

    created() {
        this.applyDefaultFilters();
    },

    mounted() {
        this.prepareResponsiveBehaviour();
        screen.orientation.addEventListener("change", (e) =>{
                // Do change
                this.refreshDeely()
        });
        this.refresh();

        window.EventBus.$on('product-quantity-change', () => {
            if (this.isDetailedCampaignDialogOpen) {
                this.onOpenDetailedCampaignDialog(this.selectedCampaign);
            }
        });
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.computeDatatableSize);
        this.resizeObserver?.unobserve(this.$refs.headerFilters);
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore, useNormalOrderStore,useAppStore),

        hasActiveFilters() {
            return Object.values(this.filters)
                .filter((x) => x) // ignore null or undefined
                .some((x) => (typeof x === 'string' && x !== '') || (Array.isArray(x) && x.length > 0) || (typeof x === 'object' && Object.keys(x).length > 0));
        },

        hasMoreCampaignPages() {
            return this.campaigns.currentPage < this.campaigns.lastPage;
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },
        headerProps(){
            return this.appStore.header_props
        }
    },

    methods: {
        hasActiveCampaign(campaign){
            let result= this.normalOrderStore.getCampaignByUniqueId(campaign.unique_id)
           return result?true:false
        },
        refreshDeely(){
            setTimeout(()=>{
                    this.refresh();
                },300)
        },
        onDataChanges(value) {
            // If the product is in the cart, we want to change the quantities accordingly.
            /*for (const [index, product] of value?.data?.entries()) {
                if (this.isInCart(product)) {
                    const item = this.normalOrderStore.getProduct(product.id);
                    this.$set(value.data, index, item);
                }
            }*/

            const wrapper = this.$refs['datatable']?.$el?.querySelector('div.v-data-table__wrapper');
            this.scrollDatatableToTop(this.$vuetify, wrapper);
        },
        prepareResponsiveBehaviour() {
            const makeResponsive = () => {
                this.computeDatatableSize();
            };

            this.resizeObserver = new ResizeObserver(makeResponsive);
            this.resizeObserver.observe(this.$refs.headerFilters);

            window.addEventListener('resize', makeResponsive);

            makeResponsive();
        },

        computeDatatableSize() {
            const topElement = this.$refs.headerFilters;

            if (topElement) {
                const topHeight = topElement.getBoundingClientRect().bottom;
                const res = window.innerHeight - 75  - topHeight;
                this.datatableSize = res;
            }
        },

        removeFilter(filters, index) {
            filters.splice(index, 1);
            this.onFiltersChanged();
        },

        onFiltersChanged() {
            setTimeout(() => {
                this.refresh();

                window.EventBus.$emit('check-if-should-overflow');
                window.EventBus.$emit('check-if-should-underflow');
            }, 300);
        },
        setItemsPorPage(){
            this.itemsPerPageOptions=window.innerWidth>=768&&window.innerWidth<=1366?[25,50,80]:[15,20,50]
        },
        refresh(options) {
            if (!this.branchStore.branch) return;

            const query = this.areAdvancedFiltersActive ? this.advancedFilters : this.filters;

            if (this.$refs.datatable) {
                if (options) {
                    this.$refs.datatable.setLocalOptions(options);
                }else{
                    options=this.$refs.datatable.localOptions
                    options.itemsPerPage=window.innerWidth>=768&&window.innerWidth<=1366?25:15
                    this.$refs.datatable.setLocalOptions(options);
                }
                this.$refs.datatable.onChangeQueryBuilder(query, this.schema);
            }
        },

        applyDefaultFilters() {
            for (let field in this.model) {
                this.$set(this.filters, field, this.model[field]);
            }
        },

        onClearFilters() {
            this.applyDefaultFilters();
            this.hasExpandedActiveFilters = false;

            this.refresh();
        },

        changeCampaignPage(amount) {
            const nextPage = this.campaigns.currentPage + amount;

            if (nextPage < 1 || nextPage > this.campaigns.lastPage) {
                return;
            }

            this.campaigns.currentPage = nextPage;
            //this.getCampaigns();
        },

        onClickProductCampaign(product) {
            this.isProductDetailsDialogOpen = false;
            this.isDetailedCampaignDialogOpen = false;

            this.selectedProduct = product;
            this.getSelectedProductCampaigns();
        },

        getCampaigns() {
            this.isLoading = true;

            if (!this.campaigns) {
                this.campaigns.currentPage = 1;
                this.campaigns.lastPage = 1;
            }

            const query = buildQueryObjectFromModel(this.filters, this.schema, { customSearch: this.customSearch });

            axios
                .get('/api/campaigns/simple', {
                    params: {
                        branch_id: this.branchStore.branch?.id,
                        page: this.campaigns.currentPage,
                        queryObject: JSON.stringify(query),
                    },
                })
                .then((response) => {
                    this.isLoading = false;
                    this.campaigns.currentPage = response.data.currentPage;
                    this.campaigns.lastPage = response.data.lastPage;
                    this.campaigns.items = response.data.campaigns;
                    this.tabItems = response.data.tabs;
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                });
        },

        getSelectedProductCampaigns() {
            this.isPageLoading = true;

            axios
                .get('/api/campaigns', {
                    params: {
                        reference: this.selectedProduct.code,
                        branch_id: this.branchStore.branch?.id,
                        campaign_id: this.selectedProduct.campaign_id,
                    },
                })
                .then((response) => {
                    this.isPageLoading = false;
                    this.productCampaigns = response.data;
                    this.originalProductCampaigns = JSON.parse(JSON.stringify(this.productCampaigns));

                    if (this.productCampaigns.length == 0) {
                        this.showError('Campanhas do produto temporariamente indisponíveis. Por favor volte a tentar mais tarde ...');
                    } else {
                        this.checkAppliedCampaigns();
                        this.isDetailedCampaignDialogOpen = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.isPageLoading = false;
                });
        },

        handleStoredMixCampaigns() {
            // Check if there are stored mixs to show
            let campaigns = [];
            const all_stored_campaigns = this.normalOrderStore.getSimpleCampaigns;

            if (all_stored_campaigns.length > 0) {
                this.productCampaigns.forEach((campaign) => {
                    const stored_campaigns = all_stored_campaigns.filter((sc) => {
                        return sc.id === campaign.id;
                    });

                    if (stored_campaigns.length > 0) {
                        stored_campaigns.forEach((stored_campaign) => {
                            campaigns.push(stored_campaign);
                        });
                    } else {
                        campaigns.push(campaign);
                    }
                });
            }

            this.manipulatedProductCampaigns =
                campaigns.length > 0 //
                    ? campaigns.sort((a, b) => a.sort - b.sort || a.index - b.index)
                    : this.productCampaigns.sort((a, b) => a.sort - b.sort || a.index - b.index);
        },

        checkAppliedCampaigns() {
            let campaigns = [];
            this.originalProductCampaigns = JSON.parse(JSON.stringify(this.productCampaigns));

            this.handleStoredMixCampaigns();

            this.manipulatedProductCampaigns.forEach((campaign) => {
                let storedCampaign = this.normalOrderStore.getCampaignByUniqueId(campaign.unique_id);

                if (storedCampaign) {
                    campaigns.push(storedCampaign);
                } else {
                    let storedCampaignFromAnotherRequirement = this.normalOrderStore.getCampaignByUniqueId(campaign.unique_id);

                    if (storedCampaignFromAnotherRequirement && storedCampaignFromAnotherRequirement.unique_id == campaign.unique_id) {
                        campaigns.push(storedCampaignFromAnotherRequirement);
                    } else {
                        const originalCampaign = JSON.parse(JSON.stringify(this.originalProductCampaigns.find((c) => c.id == campaign.id)));
                        campaigns.push(originalCampaign);
                    }
                }
            });

            this.manipulatedProductCampaigns = campaigns.sort((a, b) => a.sort - b.sort || a.index - b.index);
        },

        setDefaultSelectedTab() {
            this.selectedTab.index = -1;
            this.selectedTab.id = 0;
            this.selectedTab.name = '';
        },

        onOpenDetailedCampaignDialog(campaign) {
            this.selectedCampaign = campaign;
            this.selectedProduct = this.product;

            // Flush productCampaigns and push the new selected campaign
            this.productCampaigns.splice(0);
            this.productCampaigns.push(campaign);

            this.checkAppliedCampaigns();

            this.isDetailedCampaignDialogOpen = true;
        },

        onCloseDetailedCampaignDialog() {
            this.isDetailedCampaignDialogOpen = false;
        },

        createNewOriginalCampaign(campaign) {
            let campaigns = [];

            const newOriginalCampaign = () => {
                const originalCampaign = this.campaigns.items.find((c) => {
                    return c.id == campaign.id;
                });

                if (!originalCampaign) return false;

                const maxIndexCampaign = this.manipulatedProductCampaigns.filter((c) => c.id === campaign.id).reduce((prev, current) => (prev && prev.index > current.index ? prev : current));

                let oc = originalCampaign;
                oc.index = maxIndexCampaign.index + 1;
                oc.unique_id = oc.id + '_' + oc.index;

                // Manipulate requirements unique_id
                oc.requirements.forEach((requirement, index) => {
                    requirement.campaign_unique_id = oc.unique_id;
                    requirement.product.campaign_unique_id = oc.unique_id;
                    requirement.product.uniqueId = requirement.product.id + '_' + oc.unique_id + '_header_' + index;
                });

                // Manipulate requirements unique_id
                oc.offers.forEach((offer, index) => {
                    offer.campaign_unique_id = oc.unique_id;
                    offer.product.campaign_unique_id = oc.unique_id;
                    offer.product.uniqueId = offer.product.id + '_' + oc.unique_id + '_offer_' + index;
                });

                return oc;
            };

            this.manipulatedProductCampaigns.forEach((manipulatedCampaign) => {
                campaigns.push(manipulatedCampaign);

                if (manipulatedCampaign.unique_id === campaign.unique_id) {
                    campaigns.push(JSON.parse(JSON.stringify(newOriginalCampaign())));
                }
            });

            this.manipulatedProductCampaigns = campaigns.sort((a, b) => a.sort - b.sort || a.index - b.index);
        },
    },
};
</script>

<style>
.v-text-field {
    margin-top: 0 !important;
}

.v-text-field input {
    padding: 4px 0 !important;
    margin-top: 0 !important;
}

#form-base > div > .v-input > .v-input__control > .v-input__slot .v-input__icon--prepend-inner button.v-icon {
    color: #154579;
    font-size: 18px !important;
}
</style>
